import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-campo-texto',
  templateUrl: './campo-texto.component.html',
  styleUrls: ['./campo-texto.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CampoTextoComponent),
      multi: true
    }]
})

export class CampoTextoComponent implements ControlValueAccessor {

  @Input() id: string;
  @Input() etiqueta: string;
  @Input() mensaje_ayuda: string;
  @Input() caracteres_maximo: number = 600;
  @Input("placeholder_input") placeholder_input: string = "";
  @Input("mensaje_error") mensaje_error: string = "";
  @Input("attachment") attachment: boolean = false;
  @Output("obtener_attachments") obtener_attachments: EventEmitter<any[]> = new EventEmitter<any[]>();
  modelValue;
  private onChange = (value: string) => { };
  private onTouched = () => { };

  // Archivos adjuntos
  attachments: any[] = [];
  attachmentsErrorMessage: string = "";
  maxAmountAttachments: number = 4;
  // maxSizeAttachments = 2 MB maximo (2097152 bytes)
  maxSizeAttachments: number = 2097152;
  maxSizeAttachmentsInMB: number = this.maxSizeAttachments / 1048576;
  // Referencia al input file
  @ViewChild('fileInput') fileInput!: ElementRef;

  // Método que se llama cuando se hace clic en el botón
  onUploadClick(): void {
    this.fileInput.nativeElement.click();
  }

  writeValue(value: string): void {
    this.modelValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: string): void {
    this.modelValue = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.onChange(value);
  }

  /**
 * Se ejecuta cuando se selecciona archivos
 * @param event 
 */
  attachFiles(event) {
    var errorMsg = "Solo puedes enviar hasta " + this.maxAmountAttachments + " archivos que en total, no superen los " + this.maxSizeAttachmentsInMB + " MB.";
    if (event.target.files && event.target.files.length > 0
      && (event.target.files.length + this.attachments.length) <= this.maxAmountAttachments) {
      var filesAmount = event.target.files.length;
      var sizeTotal = 0;
      // Suma el size de los adjuntos que se acaba de agregar
      for (let i = 0; i < filesAmount; i++) {
        sizeTotal = sizeTotal + event.target.files[i].size;
      }//for
      // Suma el size de los archivos ya adjuntados
      for (let i = 0; i < this.attachments.length; i++) {
        sizeTotal = sizeTotal + this.attachments[i].size;
      }
      // Si el tamaño es menor que el maximo permitido adjunto archivos
      if (sizeTotal <= this.maxSizeAttachments) {
        // Si valdia bien me aseguro que el mensaje de error no se despliegue
        this.attachmentsErrorMessage = "";
        for (let i = 0; i < filesAmount; i++) {
          this.attachments.push(event.target.files[i]);
        }
        this.notificarAdjuntos();
      } else {
        this.attachmentsErrorMessage = errorMsg;
      }
    } else {
      // Despliega mensaje de valdiacion de cantidad de adjuntos
      this.attachmentsErrorMessage = errorMsg;
    }

  }

  /**
   * Dado un archivo por su nombre lo elimina de la coleccion de adjuntos
   * @param nombreArchivo 
   */
  eliminarAdjunto(nombreArchivo: string) {
    // Remueve el archivo seleccionado
    this.attachments = this.attachments.filter(function (file) {
      return file.name !== nombreArchivo;
    });
    // Valida si las condiciones de size y cantidad son las correctas
    if (this.attachments && this.attachments.length <= this.maxAmountAttachments) {
      var sizeTotal = 0;
      for (let i = 0; i < this.attachments.length; i++) {
        sizeTotal = sizeTotal + this.attachments[i].size;
      }
      // Si el tamaño del total de archivos es menor o igual al permitido
      if (sizeTotal <= this.maxSizeAttachments) {
        this.attachmentsErrorMessage = "";
      }
    }
    this.notificarAdjuntos();

  }

  notificarAdjuntos() {
    this.obtener_attachments.emit(this.attachments);
  }

  

}
